// extracted by mini-css-extract-plugin
export var messageSideLeft = "_si-1";
export var stateContainer = "_si-0";